export const locale = {
    lang: 'pt',
    data: {
        'NAV': {
            'APPLICATIONS': 'Formulários',
            'CONFIG': 'Configurações',
            'TOOLS': {
              'TITULO': 'Ferramentas',
              'CHAT': 'Chat',
              'TODO': 'To-Do list',
              'BROKER': 'Configuração por corretor',
              'CHANGELOG': 'Changelog',
              'KNOWLEDGE': 'Base de conhecimento',
              'WEB_COM_PROF':'Web şirket profili',
            },
            'RESULTS': {
              'TITULO': 'Resultados',
              'TI_ESPANA': 'Relatórios Online',
              'ENLACES': {
                'TI': 'Comunicando',
                'COVID': 'Resultados da pesquisa COVID'
              },
              'ENLACES_ACTION_GO':{
                'TITULO':'ActionGo',
                // 'TITULO':'Plano de Ação - Líderes',
              },
              'ENLACES_GO_FLOW':{
                'TITULO':'Resultados do Go Flow',
              }
            },
            'ACADEMY'        : {
                'TITULO': 'Test Academy',
                'BADGE': '69'
            },
            'CERTIFICAR'        : {
                'TITULO': 'Certificar',
                'TITULOIZZI': 'Izzi',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Certificar',
                  '1': 'Certificar 2.0',
                  '2': 'Izzi',
                  '3': 'Certificar 3.0',
                  '4': 'Certificar prata',
                  'SPA': 'Configurar pesquisa'
                }
            },
            'CERTIFICARN35'        : {
                'TITULO': 'Certificar N35',
                'BADGE': '69'
            },
            'MEDIR'        : {
                'TITULO': 'Medição',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Medição',
                  '1': 'Medição aprimorada',
                  '2': 'Medição + MST',
                  '3': 'Medição por áreas',
                  '4': 'Medição pelos líderes',
                  '5': 'Medição por dimensões',
                  '6': 'Medição para certificar',
                  '7': 'Medição 3.0',
                }
            },
            'PULSE'        : {
                'TITULO': 'Pulse Check',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Pulse Check',
                  '1': 'Pulse Check 3.0',
                }
            },
            'FOCUS'        : {
                'TITULO': 'Focus Area',
                'BADGE': '69'
            },
            'ENCUESTAS' : {
                'TITULO': 'Certificados adicionais',
                'BADGE': '69',
                'SUBPRODUTOS': {
                  '0': 'AMCO',
                  '1': 'Trabalho decente',
                  '2': 'Primeiro emprego',
                }
            },
            'NORMA35': {
                'TITULO': 'Norm 035'
            },
            'NOM35BETHE': {
                'TITULO': 'Norm 035 better'
            },
            'NOM35PLA': {
                'TITULO': 'Norm 035 silver'
            },
            'NOM35V3': {
                'TITULO': 'Norm 035 3.0'
            },
            'LANGUAJE'        : {
                'TITULO': 'Test languaje',
                'BADGE': '69'
            },
            'LOGIN'        : {
                'TITULO': 'Test login',
                'BADGE': '69'
            },
            'PROFILECREATOR'        : {
                'TITULO': 'Criador de perfis',
                'BADGE': '69'
            },
            'PROFILELIST'        : {
                'TITULO': 'Informações sobre empresas',
                'BADGE': '69'
            },
            'NOPRODUCTOS'        : {
                'TITULO': 'Você não tem produtos',
                'BADGE': '69'
            },
            'RESPTI': {
              'TITULO': 'Gerente de TI'
            },
            'REQTEC': {
              'TITULO': 'Requerimentos técnicos'
            },
            'CLOUD': {
              'TITULO': 'Gerenciador de arquivos',
              'TITULO_ESPANA': 'Downloads de relatórios',
            },
            //Culture Audit
            'CULTURE': {
              'TITULO': 'Culture Audit'
            },
            //Culture Audit2
            'CULTURE2': {
              'TITULO': 'Culture Audit 5.0'
            },
            //Culture Audit training
            'CATR': {
              'TITULO': 'Culture Audit Training'
            },
            //Feedback
            'FEEDBACK': {
              'TITULO': 'Feedback'
            },
            //Acercade
            'ABOUT': {
              'TITULO':'Changelog'
            },
            'QUESTIONS': {
              'TITULO':'Perguntas mais frequentes'
            },
            'VIDEOS': {
              'TITULO':'Vídeos instrutivos'
            },
            'CONSULTAR_E': {
              'TITULO':'Consultar pesquisas'
            },
            'CALEND_SUR': {
              'TITULO':'Calendário de inquéritos'
            },
            'VIDEOSADMIN': {
              'TITULO':'Vídeo do administrador'
            },
            'AUDITORIA-AUTO': {
              'TITULO':'Auditoria automatizada'
            },'TIPS': {
              'TITULO':'Norma tips'
            },'ENCUESTA': {
              'TITULO':'Colaboradores nuevos'
            },
            'CULTURETURQUIA1': {
              'TITULO': 'Culture Brief ve Auditoria de Cultura 5.0'
            },'CULTURETURQUIA2': {
              'TITULO': 'Culture Brief 5.0'
            },'CULTURETURQUIA3': {
              'TITULO': 'Auditoria de Cultura 5.0'
            },
            'CULTUREMX1': {
              'TITULO': 'Auditoria de Cultura 5.0'
            },'CULTUREMX2': {
              'TITULO': 'Auditoria de Cultura Costa Rica'
            },'CULTUREMX3': {
              'TITULO': 'Auditoria de Cultura GoFlow'
            },'CULTUREMX4': {
              'TITULO': 'Auditoria de Cultura 5.0 Panamá'
            },'CULTUREMX5': {
              'TITULO': 'Auditoria de Cultura 5.0 Strategic Partners'
            },
            'CULTUREMX11': {
              'TITULO': 'SP 2022'
            },
            'CULTUREMX12': {
              'TITULO': 'Auditoria Cultura GoFlow 2-2022'
            },
            'CULTUREMX13': {
              'TITULO': 'Norma de Auditoria de Cultura 1'
            },
            'CULTUREMX14': {
              'TITULO': 'Cultuur Audit® CA&C'
            },
            'CULTUREMX15': {
              'TITULO': 'Auditoria cultural (certificar) 2022'
            },
            'CULTUREMX16': {
              'TITULO': 'Auditoria cultural (certificar, rkg.) 2022'
            },
            'CULTUREMX17': {
              'TITULO': 'Auditoria cultural (certificar, rkg. e adic.) 2022'
            },
            'CULTUREMX18': {
              'TITULO': 'Auditoria cultural (certificar, rkg. e adic.) 2024'
            },
            'CULTUREMX19': {
              'TITULO': 'Culture Brief (certifique) 2024'
            },
            'CULTUREMX20': {
              'TITULO': 'Auditoria de Cultura (certificar e classificar) 2024'
            },
            'CULTURECH1': {
              'TITULO': 'Auditoria de Cultura'
            },'CULTURECH2': {
              'TITULO': 'Auditoria de Cultura 5.0'
            },'CULTURECH3': {
              'TITULO': 'Auditoria de Cultura SP'
            },

            'CULTUREESP1':{
              'TITULO': 'Auditoria de Cultura'
            },
            'CULTUREESP2':{
              'TITULO': 'Auditoria de Cultura 5.0'
            },
            'CULTUREESP3':{
              'TITULO': 'Plano de Ação'
            },
            'CULTUREBRI':{
              'TITULO': 'Resumo da Cultura',
              'Culture Brief': 'Resumo da Cultura',
            },
            'CULTUREAUDI':{
              'TITULO': 'Auditoria cultural',
              'Culture Audit': 'Auditoria cultural',
            },
            'CONTACTO':{
              'TITULO': 'Contacto'
            },
            'ACTIONGOADMIN':{
              'TITULO': 'Acção GO® administrador'
            },
            'ACTIONGO':{
              'TITULO': 'Acção GO®'
            },
            'LEADERGOADMIN':{
              'TITULO': 'Leader GO® administrador',
            },
            'LEADERGOUSER':{
              'TITULO': 'Leader GO®',
            },
            'medir_INNO':{
              'TITULO': 'Inquérito de lnmotion',
            },
            'CULTURE_OZEL':{
              'TITULO': 'Lista Especial',
            },
            'Culture_Ozel_TR1':{
              'TITULO': 'Responsabilidade Social e Voluntariado',
            },
            'CONTROL_SURVE':{
              'TITULO': 'Controlo dos inquéritos',
            },
            'CONSUL_REQUE':{
              'TITULO': 'Consultar requisitos',
            },
            'SURVEY_GENERIC':{
              'TITULO': 'Relatório de inquérito genérico',
            },




        }
    }
};
